import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterOutlet } from '@angular/router';

@Component({
	selector: 'authentication-layout',
	templateUrl: './authentication-layout.component.html',
	imports: [RouterOutlet, TranslateModule]
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AuthenticationLayoutComponent {

}
